<template>
  <div class="match-result dialog">
    <div class="content">
      <div class="close" @click="close"></div>
      <div class="title">排行榜</div>
      <div class="main">
        <img
          v-if="status === 'victory'"
          class="banner"
          src="https://vanthink.oss-cn-qingdao.aliyuncs.com/7d987d4845bc4e0cc80c99c28f581d8b.png" alt="">
        <img
          v-else-if="status === 'lose'"
          class="banner"
          src="https://vanthink.oss-cn-qingdao.aliyuncs.com/9bc60389227a5b8bba712876d7f08c1b.png" alt="">
        <img
          v-else
          class="banner"
          src="https://vanthink.oss-cn-qingdao.aliyuncs.com/294b02c892ca1f405f73088e06796b3d.png" alt="">
        <div class="match-info-wrapper">
          <div class="item">
            <img
              class="status-image"
              v-if="guardStatus === 'victory'"
              src="https://vanthink.oss-cn-qingdao.aliyuncs.com/8130f249b6705eaa4114853df552d0a4.png" alt="">
            <img
              class="status-image"
              v-else-if="guardStatus === 'lose'"
              src="https://vanthink.oss-cn-qingdao.aliyuncs.com/ad122b6b147862f9ee5f12ca0cd105f4.png" alt="">
            <img
              class="status-image"
              v-else
              src="https://vanthink.oss-cn-qingdao.aliyuncs.com/4b261115a3a9e95c40ea096872fb1981.png" alt="">
          </div>
          <div class="match-info item">
            <img class="board" src="https://vanthink.oss-cn-qingdao.aliyuncs.com/78549f75c85fa88e3dfae14b296fb409.png" alt="">
            <div class="score-wrapper">
              <img src="https://vanthink.oss-cn-qingdao.aliyuncs.com/ce2c5d303e87c64282a01d10311ecaad.png" alt="">
              <div class="score">
                <span class="guard">{{matchInfo.guardScore}}</span>
                <span class="colon">:</span>
                <span class="offensive">{{matchInfo.offensiveScore}}</span>
              </div>
              <img src="https://vanthink.oss-cn-qingdao.aliyuncs.com/ce2c5d303e87c64282a01d10311ecaad.png" alt="">
            </div>
          </div>
          <div class="item">
            <img
              class="status-image"
              v-if="guardStatus === 'lose'"
              src="https://vanthink.oss-cn-qingdao.aliyuncs.com/8130f249b6705eaa4114853df552d0a4.png" alt="">
            <img
              class="status-image"
              v-else-if="guardStatus === 'victory'"
              src="https://vanthink.oss-cn-qingdao.aliyuncs.com/ad122b6b147862f9ee5f12ca0cd105f4.png" alt="">
            <img
              class="status-image"
              v-else
              src="https://vanthink.oss-cn-qingdao.aliyuncs.com/4b261115a3a9e95c40ea096872fb1981.png" alt="">
          </div>
        </div>
        <div class="list-wrapper">
          <div class="list guard">
            <div
              v-for="(item, index) in matchInfo.guard"
              :key="item.id"
              class="item">
              <div class="item-left">
                <img
                  v-if="status !== 'draw' && index <= 2"
                  :src="renderRankImage(index + 1, 'guard')" alt="">
                <span v-else class="rank-text">{{ index + 1 }}</span>
                <span class="name">{{item.name}}</span>
              </div>
              <div class="score">
                {{item.score}}
                <span class="unit">分</span>
              </div>
            </div>
          </div>
          <div class="list offensive">
            <div
              v-for="(item, index) in matchInfo.offensive"
              :key="item.id"
              class="item">
              <div class="item-left">
                <img
                  v-if="status !== 'draw' && index <= 2"
                  :src="renderRankImage(index + 1, 'offensive')" alt="">
                <span v-else class="rank-text">{{ index + 1 }}</span>
                <span class="name">{{item.name}}</span>
              </div>
              <span class="score">
                {{item.score}}
                <span class="unit">分</span>
              </span>
            </div>
          </div>
        </div>
        <div class="match-time">
          <div class="time">比赛时间: {{formatDate}}</div>
          <div class="date">比赛用时: {{secondsToTime}}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import utils from '@/services/utils';

export default {
  props: {
    matchInfo: {
      type: Object,
      default: () => {},
    },
    isGuardMember: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    secondsToTime() {
      const start = new Date(this.matchInfo.startTime).getTime();
      // const end = new Date(this.matchInfo.endTime);
      const end = new Date().getTime();
      const duration = parseInt((end - start) / 1000, 0);
      return utils.secondsToTime(duration);
    },
    status() {
      const { offensiveScore = 0, guardScore = 0 } = this.matchInfo;
      let status = 'draw';

      if (guardScore > offensiveScore) {
        status = this.isGuardMember ? 'victory' : 'lose';
      } else if (guardScore < offensiveScore) {
        status = this.isGuardMember ? 'lose' : 'victory';
      }
      return status;
    },
    guardStatus() {
      const { offensiveScore = 0, guardScore = 0 } = this.matchInfo;
      let status = 'draw';

      if (guardScore > offensiveScore) {
        status = 'victory';
      } else if (offensiveScore > guardScore) {
        status = 'lose';
      }
      return status;
    },
    formatDate() {
      const date = new Date(this.matchInfo.startTime);
      return utils.Date.format(date, 'yyyy-MM-dd');
    },
  },
  methods: {
    close() {
      this.$emit('close');
    },
    renderRankImage(rank, type = 'guard') {
      let url = '';
      if ((this.guardStatus === 'victory' && type === 'guard')
        || (this.guardStatus === 'lose' && type === 'offensive')) {
        switch (rank) {
          case 1:
            url = 'https://vanthink.oss-cn-qingdao.aliyuncs.com/a23f5736a1512dc22983c4dc0ae4bceb.png';
            break;
          case 2:
            url = 'https://vanthink.oss-cn-qingdao.aliyuncs.com/7b75b2f3cda8d75d243383ab693303cf.png';
            break;
          case 3:
            url = 'https://vanthink.oss-cn-qingdao.aliyuncs.com/0b5ee73d160a56751bae9cc9952dd48f.png';
            break;
          default:
            url = '';
        }
      } else {
        switch (rank) {
          case 1:
            url = 'https://vanthink.oss-cn-qingdao.aliyuncs.com/bd3d7455087d1ed41bcea45c4338c56e.png';
            break;
          case 2:
            url = 'https://vanthink.oss-cn-qingdao.aliyuncs.com/b4daf7743f8ad05aa69b31cfbb801904.png';
            break;
          case 3:
            url = 'https://vanthink.oss-cn-qingdao.aliyuncs.com/618445e13668dc68e3c5111b5e2d11f8.png';
            break;
          default:
            url = '';
        }
      }
      return url;
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '@/styles/variables.scss';
  @import "@/styles/common/dialog.scss";
  .match-result {
    width: 82vw;
    height: 90vh;
    z-index: 9998;
    color: #333;
    .content {
      display: flex;
      flex-direction: column;
      overflow: hidden;
      .main {
        position: relative;
        flex: 1;
        width: 100%;
        text-align: center;
        color: #333;
        background: #fff;
        border-radius: 24px 24px 0 0;
        overflow-y: auto;
        .banner {
          width: 100%;
        }
        .match-info-wrapper {
          display: flex;
          justify-content: center;
          width: 100%;
          .item {
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            .status-image {
              width: 70%;
            }
          }
          .match-info {
            .board {
              width: 70%;
            }
            .score-wrapper {
              margin-top: 5px;
              padding: 5px;
              display: flex;
              align-items: center;
              background: $primary;
              border-radius: 10px;
              img {
                width: 2.2vw;
              }
              .score {
                margin: 2px 5px;
                padding: 2px;
                min-width: 6vw;
                color: #333;
                font-size: 3vh;
                font-weight: 700;
                background: #fff;
                border-radius: 10px;
                .guard {
                  color: #0a69e3;
                  vertical-align: middle;
                }
                .colon {
                  margin: 0 4px;
                  display: inline-block;
                  color: $primary;
                }
                .offensive {
                  color: #DE1919;
                  vertical-align: middle;
                }
              }
            }
          }
        }
        .list-wrapper {
          display: flex;
          justify-content: space-between;
          margin: 20px auto 0;
          padding: 20px 10px 0;
          width: 85%;
          .list {
            width: 45%;
            .item {
              box-sizing: border-box;
              display: flex;
              justify-content: space-between;
              align-items: center;
              margin-bottom: 20px;
              padding: 10px 20px;
              width: 100%;
              height: 12vh;
              font-size: 3vh;
              color: $primary;
              font-weight: 700;
              border-radius: 15px;
              box-shadow:0px 0px 4px $primary;
              .item-left {
                width: 60%;
                display: flex;
                align-items: center;
                img {
                  margin-right: 20px;
                  width: 7vh;
                }
                .name {
                  display: inline-block;
                  width: 20vw;
                  text-align: left;
                  overflow: hidden;
                  text-overflow: ellipsis;
                  white-space: nowrap;
                }
              }
              .rank-text {
                display: inline-block;
                margin-right: 20px;
                width: 7vh;
              }
              .score {
                .unit {
                  font-size: 2.4vh;
                }
              }
            }
          }
        }
        .match-time {
          display: flex;
          justify-content: space-between;
          margin: 0 auto 20px;
          width: 85%;
          color: $primary;
          font-size: 2.2vh;
        }
      }
    }
  }
</style>
